import React, { PureComponent } from "react";
import { CircleSpinner } from "react-spinners-kit";
import { Button, Card, CardActions, FontIcon } from "react-md";
import { withSnackbar } from "notistack";
import { objToArrayWithId } from './services/array';
import swal from 'sweetalert2';
import firebase from "firebase/app";

import TankCreateOrEdit from './TankCreateOrEdit';

class TanksManager extends PureComponent {
  constructor() {
    super();
    this.state = {
      loading: true,
      sensors: [],
      visible: false,
      isAdmin: false,
      clienteSensors: []
    };
  }

  async componentDidMount(){
    await this.load();
  }

  load = () => {
    this.setState({ loading: true });
    let FIREBASE_REF_SENSORS = firebase.database().ref('/storage/sensors_list');
    FIREBASE_REF_SENSORS.once("value").then(async (snapshot) => {
      let sensors = objToArrayWithId(snapshot.val());

      if (this.state.isAdmin) {
        this.setState({ sensors: [...sensors], loading: false });
      } else {
        let uid = firebase.auth().currentUser.uid
        firebase.database().ref(`/storage/users/${uid}/sensors`).once('value', async (clienteSensorsSnapshot) => {
          let clienteSensors = clienteSensorsSnapshot.val();
          await clienteSensorsSnapshot.forEach(element => {
              firebase.database().ref(`/storage/sensors_list/${element.key}`)
                .once("value")
                .then((snapshot) => {
                let sensors = snapshot.val();
                this.setState({ sensors: [...this.state.sensors, sensors] })
            })
          })
          await this.setState({ clienteSensors, loading: false });
        })
      }
    });
  }

  openSensorDialog = (item, disabled = false) => {
    this.refs.createOrEdit.show(item, disabled, this.state.isAdmin, this.state.clienteSensors);
  };

  delete = (item) => {
    swal.fire({
      title: 'Are you sure?',
      text: `Are you sure want to delete the sensor ${item.id} ?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      let uid = await firebase.auth().currentUser.uid;
      if (result.value) {
        if (this.state.isAdmin) {
          await firebase.database().ref(`/storage/sensors_list/${item.id}`)
            .remove()
            .then(() => {
              firebase.database().ref(`/storage/users/${uid}/sensors/${item.id}`)
              .remove()
              .then(() => {
              this.props.enqueueSnackbar("Data Deleted!", { variant: "success" });
              })
            })
            .catch((error)=>{
              this.props.enqueueSnackbar(error, { variant: "error" });
            });
        } else {          
          await firebase.database().ref(`/storage/users/${uid}/sensors/${item.id}`)
            .remove()
            .then(() => {
              firebase.database().ref(`/storage/sensors_list/${item.id}/users/${uid}`)
              .remove()
              .then(() => {
              this.props.enqueueSnackbar("Data Deleted!", { variant: "success" });
              })
            }).catch((error) => {
              this.props.enqueueSnackbar(error, { variant: "error" });
            });
        }
      }
    });
  }

  render() {
    let { loading, sensors, isAdmin } = this.state;

    if (loading)
      return (
        // Loading spinner...
        <div className="spinner">
          <CircleSpinner
            size={50}
            color="#2196F3"
            loading={loading}
          />
        </div>
      );
    return (
      <div>

        <TankCreateOrEdit ref='createOrEdit' modalSave={() => { /*this.load()*/ }} />

        <div className="md-grid">
          {sensors.map((item, i) => {
            let tank;
            if (item && item.props && item.props.tank)
              tank = item.props.tank;

            return (
              <div className="md-cell md-cell--12 md-cell--3-desktop" key={i}>
                <Card style={{
                  padding: "15px",
                  borderRadius: "5px"
                }} className="md-block-centered">

                  <div onClick={() => { this.openSensorDialog(item, true); }}>

                    <div className="md-text md-divider-border md-divider-border--bottom">
                      {tank.id}
                    </div>

                    <div style={{
                      fontWeight: 'bold',
                      fontSize: '20px',
                    }} className="md-text">{tank.name}</div>

                    <div className="md-grid md-text">
                      <div className="md-cell md-cell--2 md-cell--6-desktop ">
                        Capacity:
                      <br />
                        {(tank && tank.capacity) ? tank.capacity : 0}
                      </div>
                      <div className="md-cell md-cell--2 md-cell--6-desktop">
                        Status:
                      <br />
                        {(tank && tank.status) ? <FontIcon>check</FontIcon> : <FontIcon>close</FontIcon>}
                      </div>
                    </div>

                  </div>

                  <CardActions className="md-divider-border md-divider-border--top">
                    {
                      isAdmin ?
                        <Button raised primary className="md-cell--left"
                          onClick={() => { this.openSensorDialog(item); }}>
                          Edit
                        </Button>
                        : null
                    }

                    <Button raised className="md-cell--right"
                      onClick={() => { this.delete(item); }}>
                      Delete
                    </Button>
                  </CardActions>
                </Card>
              </div>
            );
          })}
        </div>

        <Button floating primary swapTheming onClick={() => { this.openSensorDialog(); }}
          style={{
            float: 'right',
            backgroundColor: 'white',
            bottom: '15px',
            right: '15px'
          }}>add</Button>

      </div >
    );
  }
}

export default withSnackbar(TanksManager);